import moment from 'moment';

export const AURA_ONLY_APPOINTMENT_TYPE = 'Aura encounter';

export const capitalizeFirstLetter = (str) => {
  return str?.charAt(0).toUpperCase() + str?.slice(1);
};

export const parseCustomDate = (dateString) => {
  const dateRegex =
    /(\w{3}) (\d{1,2})(st|nd|rd|th), (\d{4}), (\d{1,2}).(\d{2}) (AM|PM)/;
  const match = dateString.match(dateRegex);

  if (!match) {
    return null;
  }

  // eslint-disable-next-line no-unused-vars
  const [, month, day, _, year, hour, minute, ampm] = match;
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const monthIndex = months.indexOf(month);

  let hours = parseInt(hour, 10);
  if (ampm.toLowerCase() === 'pm' && hours < 12) {
    hours += 12;
  }
  if (ampm.toLowerCase() === 'am' && hours === 12) {
    hours = 0;
  }

  return new Date(year, monthIndex, day, hours, parseInt(minute, 10));
};

export const statusSorter = (a, b) => {
  return a.intakeStatus.localeCompare(b.intakeStatus);
};

// Commenting this after we included email to display for same practitioners
//   export const uniqueDoctorNames = Array.from(
//     new Set(filterOptions?.doctorNames?.map((doctor) => JSON.stringify(doctor)))
//   )?.map((jsonString) => JSON.parse(jsonString));
//

export const DateOptions = [
  { title: 'Today', value: 'Today' },
  { title: 'Tomorrow', value: 'Tomorrow' },
  { title: 'Next 7 days', value: 'Next 7 days' },
  { title: 'Yesterday', value: 'Yesterday' },
  { title: 'Past 7 days', value: 'Past 7 days' },
  { title: 'All time', value: 'All time' },
  { title: 'Custom…🗓️', value: 'Custom…🗓️' },
];

export const customDateTimeSorter = (a, b) => {
  const dateA = moment(a.appointmentDateTime.date, 'MMM Do, YYYY');
  const dateB = moment(b.appointmentDateTime.date, 'MMM Do, YYYY');

  // A negative value indicates that a should come before b.
  // A positive value indicates that a should come after b.
  // Zero or NaN indicates that a and b are considered equal.
  if (dateA.isBefore(dateB)) {
    return -1;
  } else if (dateA.isAfter(dateB)) {
    return 1;
  } else {
    const timeA = moment(a.appointmentDateTime.time, 'h:mm A');
    const timeB = moment(b.appointmentDateTime.time, 'h:mm A');

    if (timeA.isBefore(timeB)) {
      return 1;
    } else if (timeA.isAfter(timeB)) {
      return -1;
    } else {
      return 0;
    }
  }
};

export const patient_nameSorter = (a, b) => {
  const lastNameA = a.patient_Name.toLowerCase();
  const lastNameB = b.patient_Name.toLowerCase();

  return lastNameA.localeCompare(lastNameB);
};

export const condition_nameSorter = (a, b) => {
  return a.condition_name.localeCompare(b.condition_name);
};

export const getReminderTime = (responseTime) => {
  if (!responseTime) {
    return null;
  }

  const currentTime = moment.utc();
  const tooltipTime = moment.utc(responseTime);
  let tooltipTimeText = null;

  if (currentTime.isSame(tooltipTime, 'day')) {
    tooltipTimeText = 'Today';
  } else if (currentTime.diff(tooltipTime, 'days') === 1) {
    tooltipTimeText = '1 day ago';
  } else {
    const daysDifference = currentTime.diff(tooltipTime, 'days');
    tooltipTimeText = `${
      daysDifference > 0 ? `${daysDifference} days ago` : 'Today'
    }`;
  }

  return tooltipTimeText;
};
